import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-cream warm-glow-light py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dy1o32dpwry5">
        <div className="text-center" data-id="element-123" data-mp="2bjywu82apiww">
          <span className="inline-flex items-center gap-2 rounded-md bg-forest px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-goldLight" data-id="element-124" data-mp="2bixo4a8r58ic">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="21lswvw01umuo" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-126" data-mp="1wnholppekkek">
            The {totalVolumes} comprehensive volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-127" data-mp="l7t2f0jz3pet">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-line bg-white shadow-card" data-id="element-128" data-mp="1iw0bqdvay8fz" data-mpi={index}>
                <div className="flex items-center gap-4 bg-forest px-6 py-5" data-id="element-129" data-mp="14v7idwgqljeg">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-gold text-forestDeep" data-id="element-130" data-mp="14xacarl0fwog">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-131" data-mp="v54qjzlcqbhp" />
                  </span>
                  <div data-id="element-132" data-mp="h652ou5ny0ml">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-mossGlow" data-id="element-133" data-mp="h6xxqxv9f1ow">
                      Volume {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-134" data-mp="2ntvn6p1t01wi">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-135" data-mp="2j244f0ow30gx">
                  <p className="font-semibold text-earth" data-id="element-136" data-mp="2e3khawyk7imz">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-muted" data-id="element-137" data-mp="295ixuax81haz">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-138" data-mp="36qnbxe04797y">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 gap-2" data-id="element-139" data-mp="31s3plchlzvf2">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-ink" data-id="element-140" data-mp="2st8k62me2pct">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forestSoft" aria-hidden="true" data-id="element-141" data-mp="2svl1cdkbovot" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-forestSoft bg-mossSoft p-4 text-sm leading-relaxed text-ink" data-id="element-142" data-mp="3t1evupipoa8z">
                    <b className="font-extrabold text-forest" data-id="element-143" data-mp="wuiqgq0t89f">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-forest px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-144" data-mp="ap0bhso3jtpo">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-mossGlow" data-id="element-145" data-mp="kld4eobti3jd">Main collection</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-146" data-mp="omox52pzn4vs">
            {totalVolumes} premium volumes <span className="mx-2 text-goldLight" data-id="element-147" data-mp="tmjlayidpgd5">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}